import { render, staticRenderFns } from "./all_text.vue?vue&type=template&id=016197ac&scoped=true&"
import script from "./all_text.vue?vue&type=script&lang=js&"
export * from "./all_text.vue?vue&type=script&lang=js&"
import style0 from "./all_text.vue?vue&type=style&index=0&id=016197ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016197ac",
  null
  
)

export default component.exports